/**
 * SalesEngine - Handles clip sales and wire pricing logic
 * 
 * Strategy: Strangler Pattern
 * - GameState delegates sales/pricing calculations to this engine
 * - Engine mutates GameState directly (preserves exact behavior)
 * - sellClips() stays on GameState (canonical operation)
 * 
 * CRITICAL: Preserve exact calculation order for golden-master tests
 */

import type { GameState } from '../GameState';

export class SalesEngine {
  /**
   * Slow tick sales processing - runs every 100ms
   * Handles wire price fluctuation and clip sales
   * 
   * IMPORTANT: Code copied verbatim from GameState.slowTick() lines 348-358
   * Do NOT refactor, reorder, or optimize - order matters for determinism
   */
  runSlowSales(gs: GameState, tickMult: number): void {
    // Wire price fluctuation
    if (gs.humanFlag) {
      const fluctuation = (Math.random() - 0.5) * 2;
      gs.wireCost = Math.max(15, Math.min(30, gs.wireBasePrice + fluctuation));
    }

    // Sales processing
    if (gs.unsoldClips > 0) {
      const clipsSelling = Math.min(gs.unsoldClips, Math.floor(gs.demand * tickMult));
      gs.sellClips(clipsSelling);
    }
  }
}
